import { Component } from 'react'
import { observer } from 'mobx-react'
import { Flex, Box } from 'reflexbox'

import * as h from 'h'

import ActualLanding from 'containers/Landing/ActualLanding'
import Header from 'components/Header'
import Footer from 'components/Footer'
import Menu from 'components/Menu'

import styles from './styles.scss'

@observer(['UiStore'])
export default class Container extends Component {
  get showMenu () {
    return this.props.UiStore.showMenu
  }

  render () {
    return h.h(Flex, {
      // set up column flex for sticky footer
      column: true,
      justify: 'space-between',
      ...h.ca(styles.container, { [styles.hasMenu]: this.showMenu })
    },
      // absolute-positioned elements
      h.h(ActualLanding), // landing
      // actual content, fill with flex auto
      h.h(Box, { auto: true },
        h.h(Header),
        h.h(Menu),
        h.h(Flex, null,
          h.h(Box, { auto: true, m: 2 },
            this.props.children))),
      // sticky footer
      h.h(Footer))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Container/index.js